import { useDispatch, useSelector } from "react-redux";
import CustomDialog from "./CustomDialog";
import { setDeleteMassage, setShowMassage } from "../store/sysSlice";
import { Divider, Stack, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";

const DeleteMassage = () => {
  const theme = useTheme()
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const data = useSelector((state) => state?.sys.deleteMassage);
  const [validationData, setValidationData] = useState('')
  const [error, setError] = useState(false)

  useEffect(() => {
    if (data?.massage) {
      setValidationData('')
      setError(false)
    }
  }, [data]);

  const onClose = () => {
    dispatch(setDeleteMassage({ massage: null, onClick: () => { } }));
  };

  const onClick = () => {
    if (data?.validation && `${data?.validation}` !== `${validationData}`) {
      setError(true)
      dispatch(setShowMassage({ massage: "DATA_DOES_NOT_MATCH", type: "error" }));
      return
    }

    data?.onClick();
    onClose();
  };

  return (
    <CustomDialog
      title="DELETE"
      open={data?.massage ? true : false}
      onClose={onClose}
      closeBtn="CANCEL"
      actionBtn={{ title: 'CONTINUE', onClick: () => onClick() }}
    >
      <Stack height="100%" spacing={1}>

        <Typography textAlign='center' variant="h6">{bt(data?.massage)}</Typography>

        {data?.validation
          ? <Stack alignItems='center' spacing={1}>
            <Divider sx={{ width: '100%' }} />
            <Stack justifyContent='center' direction='row' spacing={1}>
              <Typography fontWeight='bold'>{`${bt('ENTER')}`}</Typography>
              <Typography color='error.text' fontWeight='bold'>{`${data?.validation}`}</Typography>
              <Typography fontWeight='bold'>{`${bt('FOR_CONFIRM_DELETION')}`}</Typography>
            </Stack>

            <TextField
              fullWidth
              value={validationData}
              error={error}
              onChange={(e) => setValidationData(e.target.value)}
            />
            <Divider sx={{ width: '100%' }} />
          </Stack>
          : null
        }

        <Typography
          textAlign='center'
          variant={isMobile ? "subtitle2" : "subtitle1"}
          fontWeight="bold"
          color="error.text"
        >
          {bt("DELETE_INFO")}
        </Typography>

      </Stack>
    </CustomDialog>
  );
};
export default DeleteMassage;
